import { Component } from '@angular/core';
import { BaseIndexPageComponent } from 'src/app/components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from 'src/app/components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from 'src/app/components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from 'src/app/components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from 'src/app/services/api/api-options.config';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-projects-checklist-group-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './projects-checklist-group-index-page.component.html',
  styleUrl: './projects-checklist-group-index-page.component.scss'
})
export class ProjectsChecklistGroupIndexPageComponent {
  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected projectsService: ProjectsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Checklist Group',
      cardTitle: 'Manage Checklist Groups',
      addNewItemButton: {
        type: 'success',
        title: 'Add Checklist Group',
        onClick: () => {
          this.routeService.projectsSettingsChecklistGroupCreate();
        }
      },
      dataTable: {
        data: [],
        searchModel: {},
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => item.code
          }),
          new DataTableColumnText({
            attribute: 'name',
            header: 'Name',
            filter: 'text',
            value: (item: any) => item.name
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View checklist group details',
                onClick: (item: any) => {
                  this.routeService.projectsSettingsChecklistGroupDetail(item.checklistGroupId);
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit checklist group',
                onClick: (item: any) => {
                  this.routeService.projectsSettingsChecklistGroupUpdate(item.checklistGroupId);
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete checklist group',
                onClick: (_item: any) => {},
                isDelete: true
              }
            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.projectsService.listSettingsChecklistGroup(options),
      responseListModelName: 'checklistGroups'
    };
  }
}
